<template>
  <div class="intervention-container">
    <div class="outer-circle">
      <div class="inner-circle">
        <img
          :src="
            require('../../assets/images/konstrukcija/desktop_pozicije/' +
              ('' + current_position).padStart(2, '0') +
              '_icon.svg')
          "
          alt=""
        />
      </div>
    </div>
    <!-- Ovaj div je prikazan samo kada je moguce postaviti izolaciju sa dve strane
                (iznad/ispod | unutra/spolja) => samo tada se vide tab titles -->
    <div class="mode" v-if="get_bottom_image_data.array.length > 1">
      <div :class="{ 'mode-left': true, active: bottom.image === 'b' }" @click="value_change_new('bottom_image', 'b')">
        {{
          current_position == 18
            ? main_data.pos_above.title
            : current_position == 19
            ? main_data.pos_above.title
            : main_data.pos_outside.title
        }}
      </div>
      <div :class="{ 'mode-right': true, active: bottom.image === 'c' }" @click="value_change_new('bottom_image', 'c')">
        {{
          current_position == 18
            ? main_data.pos_below.title
            : current_position == 19
            ? main_data.pos_below.title
            : main_data.pos_inside.title
        }}
      </div>
    </div>
    <div ref="image" class="image">
      <div>
        <!-- Podrzan slucaj u kojem je slika B uklonjena (@bigknauf),
              kada drzava ne zeli gornju izolaciju, a bottom.image === 'b' (sklop 18) -->
        <img ref="imageA" v-if="bottom.image === 'b' && get_bottom_image_data.images.b" :src="get_bottom_image_data.images.b" alt />
        <img ref="imageB" v-else :src="get_bottom_image_data.images.c" alt />
      </div>
    </div>
    <div :class="['info-row', 'second', get_bottom_standard_title[2]]">
      {{ get_bottom_standard_title[0] }}
    </div>
    <div class="info-row third">
      <div class="left">{{ main_data.pos_insulation.title }}</div>
      <div :class="['right', get_bottom_standard_title[2]]">
        {{ bottom.debljina_izolacije.toFixed(0) }}
      </div>
    </div>
    <div class="regular">
      <div class="middle">
        <vue-slider
          min="0"
          max="30"
          thumbColor="image"
          :value="bottom.debljina_izolacije"
          @input="value_change_new('bottom_debljina_izolacije', $event)"
          :index="get_standard_data_array"
          class="slider"
        ></vue-slider>
      </div>
    </div>
    <div class="info-row third third-second">
      <div class="left">U (W/m<sup>2</sup>K)</div>
      <div :class="['right-second', get_bottom_standard_title[2]]">
        {{ app_math.numberWithCommas(get_pos_status_u[current_position].bottom.current) }}
      </div>
    </div>
    <div
      :class="{
        'info-row': true,
        sixth: true,
        red: get_bottom_standard_title[2] === 'red',
        'dark-green': get_bottom_standard_title[2] === 'dark-green',
        orange: get_bottom_standard_title[2] === 'orange',
        green: get_bottom_standard_title[2] === 'green',
      }"
    >
      {{ get_bottom_standard_title[0] }} (Umax {{ get_bottom_standard_title[2] === "red" ? "&gt;" : "&lt;=" }}
      {{ get_bottom_standard_title[1] }})
    </div>
    <div class="description">
      <!-- Podrzan slucaj u kojem je slika B uklonjena (@bigknauf),
              kada drzava ne zeli gornju izolaciju, a bottom.image === 'b' (sklop 18) -->
      <div v-if="bottom.image === 'b' && get_bottom_image_data.images.b">{{ get_bottom_image_data.titles.b }}</div>
      <div v-else>{{ get_bottom_image_data.titles.c }}</div>
    </div>
    <div class="button" @click="$emit('confirm-step', 8)">
      {{ main_data.list_add_insulation.title }}
    </div>

    <div class="back" @click="$emit('back-step')">
      {{ main_data.pos_intervention_back.title }}
    </div>
  </div>
</template>

<style lang="scss" scoped>
.intervention-container {
  width: 42rem;
  background-color: $main_header_middle;
  border-radius: 5rem;
  padding: 4rem 4rem 3rem 4rem;
  position: relative;

  .outer-circle {
    position: absolute;
    width: 10.3rem;
    top: 0;
    height: 10.3rem;
    left: -5.15rem;
    background-color: rgba(176, 210, 85, 0.51);
    border-radius: 50%;

    .inner-circle {
      position: absolute;
      width: 7.1rem;
      height: 7.1rem;
      top: calc(50% - 3.55rem);
      left: calc(50% - 3.55rem);
      background-color: $pos_back;
      border-radius: 50%;
      z-index: 1;
      display: flex;
      justify-content: center;
      align-items: center;

      img {
        width: 120%;
        max-width: 120%;
      }
    }
  }

  .mode {
    font-family: F-Dem;
    font-size: 1.8rem;
    line-height: 1.22;
    text-align: center;
    display: flex;
    height: 7.2rem;
    margin-top: -4rem;
    margin-left: -4rem;
    width: calc(100% + 8rem);

    div {
      flex: 0 0 50%;
      color: $main_header_light;
      background-color: rgba(29, 78, 96, 0.39);
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;

      &.mode-left {
        padding-left: 3rem;
      }

      &.mode-right {
        padding-right: 3rem;
      }

      &.active {
        color: $pos_back;
        // border-bottom: 2px solid $pos_back;
        background-color: transparent;
      }
    }
  }

  .image {
    img {
      display: block;
      margin: auto;
      height: 27rem;
      width: auto;
      max-width: 90%;
    }
  }

  .red {
    color: $calc_back;
  }

  .orange {
    color: $calc_warning;
  }

  .green {
    color: $pos_back;
  }

  .dark-green {
    color: $desktop_green;
  }

  .info-row {
    text-align: center;
    line-height: 1.3;
    font-size: 1.6rem;
    line-height: 1.25;

    &.second {
      font-family: F-Dem;
      font-size: 3.4rem;
      line-height: 0.9;
      min-height: 7.5rem;
    }

    &.third {
      display: flex;
      align-items: center;
      margin-bottom: 2.5rem;

      &.third-second {
        margin-bottom: 2rem;
      }

      .left {
        font-size: 1.4rem;
        line-height: 1.07;
        text-align: left;
        flex-grow: 1;
      }

      .right {
        font-size: 1.8rem;
        line-height: 1.17;
        text-align: right;
        font-weight: bold;
      }

      .right-second {
        font-size: 1.6rem;
        line-height: 1.2;
        text-align: right;
      }
    }

    &.sixth {
      font-family: F-Dem;
      font-weight: bold;
      text-align: left;
      font-size: 1.5rem;
      line-height: 1.31;
      min-height: 4.5rem;
    }
  }

  .regular {
    height: 3.5rem;

    .slider {
      display: flex;
    }
  }

  .description {
    font-size: 1.4rem;
    line-height: 1.21;
    text-align: left;
    color: $main_header_light;
    margin-bottom: 4rem;
  }

  .button {
    width: 100%;
    height: 6.4rem;
    border-radius: 3.2rem;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 2.4rem;
    line-height: 1.17;
    color: $text_white;
    background-color: $pos_back;
    cursor: pointer;
    margin-bottom: 1.9rem;
  }

  .back {
    font-size: 2.1rem;
    line-height: 1.19;
    color: $pos_back_inside;
    cursor: pointer;
  }
}
</style>

<script>
import app_math from "../../lib/math.js";
import helpers from "../../lib/helpers.js";
import mixin from "../../lib/mixins.js";
import slider from "../../components/slider";
import superconsole from "../../lib/superconsole.js";

export default {
  mixins: [mixin],
  data: function () {
    return {
      app_math: app_math,
    };
  },
  components: {
    "vue-slider": slider,
  },
  props: ["main_data", "current_position", "get_sklopovi_data", "get_loc_u_max", "get_povrsine", "get_pos_status_u"],
  computed: {
    top: function () {
      return {
        image: this.main_data.pos_status.value[this.current_position].top_image,
      };
    },
    bottom: function () {
      return {
        image: this.main_data.pos_status.value[this.current_position].bottom_image,
        debljina_izolacije: this.main_data.pos_status.value[this.current_position].bottom_debljina_izolacije * 100,
      };
    },
    get_standard_data_array: function () {
      return app_math.get_standard_data_array(
        this.main_data.pos_standard,
        this.get_loc_u_max,
        this.current_position,
        this.main_data.pos_status,
        this.main_data.typ_dubina,
        this.main_data.typ_vrstatla,
        this.get_povrsine.povrsina_jednog_sprata,
        this.get_povrsine.duzina_strane_kuce,
        this.get_position_type,
        this.main_data.app_sklopovi,
        this.get_sklopovi_data,
        {
          image: this.main_data.pos_status.value[this.current_position].top_image,
          debljina_zida: this.main_data.pos_status.value[this.current_position].top_debljina_zida * 100,
          debljina_izolacije: this.main_data.pos_status.value[this.current_position].top_debljina_izolacije * 100,
          debljina_izolacije_default:
            this.main_data.pos_status.value[this.current_position].top_debljina_izolacije_default * 100,
          window_type: this.get_top_sklop_data.tip_prozora,
        },
        this.get_top_sklop_data,
        this.get_bottom_sklop_data.tip_prozora
      );
    },
    get_top_sklop_data: function () {
      return helpers.get_top_sklop_data(
        this.main_data.app_sklopovi.data,
        this.main_data.pos_status.value[this.current_position].top_image,
        this.main_data.pos_status.value[this.current_position].top_debljina_zida * 100,
        this.main_data.pos_status.value[this.current_position].top_debljina_izolacije_default * 100
      );
    },
    get_bottom_sklop_data: function () {
      return helpers.get_top_sklop_data(
        this.main_data.app_sklopovi.data,
        this.main_data.pos_status.value[this.current_position].bottom_image
          ? this.main_data.pos_status.value[this.current_position].bottom_image
          : this.main_data.pos_status.value[this.current_position].top_image
      );
    },
    get_bottom_image_data: function () {
      let data = {};
      data.array = [];
      data.images = {};
      data.titles = {};
      if (this.main_data.app_sklopovi_b.images[this.top.image]) {
        data.array.push("b");
        data.images.b = this.main_data.app_sklopovi_b.images[this.top.image];
        data.titles.b = this.main_data.app_sklopovi_b.select[this.top.image];
      }
      if (this.main_data.app_sklopovi_c.images[this.top.image]) {
        data.array.push("c");
        data.images.c = this.main_data.app_sklopovi_c.images[this.top.image];
        data.titles.c = this.main_data.app_sklopovi_c.select[this.top.image];
      }
      return data;
    },
    get_position_type: function () {
      if (this.current_position == "10" || this.current_position == "13" || this.current_position == "60") {
        return 2;
      } else if (this.current_position == "20" || this.current_position == "21") {
        return 3;
      } else {
        return 1;
      }
    },
    get_bottom_standard_title: function () {
      let standard = 0;
      let iterator;
      for (iterator of this.get_standard_data_array) {
        const bvi = +this.bottom.debljina_izolacije;
        if ((bvi >= iterator[0] && bvi < iterator[1]) || (bvi === 30 && iterator[1] === 30)) {
          standard = iterator[3];
          break;
        }
      }
      return [
        standard === 0
          ? this.main_data.pos_u_value_low.title
          : standard === 1
          ? this.main_data.pos_u_value_good.title
          : this.main_data.pos_standard.select[standard - 1],
        iterator[2],
        iterator[4],
        standard === 0 ? this.main_data.pos_u_value_low.title : this.main_data.pos_u_value_good.title,
      ];
    },
  },
  methods: {
    value_change_new: function (name, value) {
      if (name === "bottom_image") {
        this.set_values("bottom_image", { bottom_image: value });
      } else if (name === "bottom_debljina_izolacije") {
        this.set_values("bottom_debljina_izolacije", { bottom_debljina_izolacije: value });
      }
    },
    set_values: function (type, value) {
      const res = app_math.calculate_status_change(
        type,
        value,
        this.current_position,
        this.main_data.app_sklopovi,
        this.get_sklopovi_data,
        this.main_data.app_sklopovi_a,
        this.main_data.app_sklopovi_b,
        this.main_data.app_sklopovi_c,
        this.main_data.pos_standard,
        this.get_loc_u_max,
        this.main_data.pos_status,
        this.main_data.typ_dubina,
        this.main_data.typ_vrstatla,
        this.get_povrsine
      );
      superconsole.log(res);
      for (const key of Object.keys(res.emit_status)) {
        this.emit_status(key, res.emit_status[key]);
      }
    },
    emit_status: function (prop, value) {
      let event = { value: this.current_position };
      event[prop] = value;
      this.$emit("set-status-data", event);
    },
  },
};
</script>
